import React, { useState } from 'react';
import { ApChip } from '@alixpartners/ui-components';
import { StyledMenu, CounterWrapper } from './NavFilter.styles';
import { FilterMenuContentDebounced } from './FilterMenuContent';

export const NavFilter = ({
	name,
	options,
	label,
	onChange,
	maxSelected,
	selected,
	order,
	groupLabels,
	delay,
}) => {
	const [isOpen, setOpen] = useState(false);
	const [showVirtualList, setShowVirtualList] = useState(false);

	const toggleMenu = open => {
		setOpen(open);
	};
	const selectedCount = (selected && selected.length) || 0;

	return (
		<StyledMenu
			button={
				<div style={{ width: 'fit-content', position: 'relative', order }}>
					{!!selectedCount && <CounterWrapper>{selectedCount}</CounterWrapper>}
					<ApChip small selected={isOpen || !!selectedCount}>
						{label || name}
					</ApChip>
				</div>
			}
			placement="bottom-start"
			toggleMenu={toggleMenu}
			isOpen={isOpen}
			isVirtualList={showVirtualList}
		>
			<FilterMenuContentDebounced
				setShowVirtualList={setShowVirtualList}
				options={options}
				onChange={onChange}
				maxSelected={maxSelected}
				selected={selected || []}
				isOpen={isOpen}
				groupLabels={groupLabels}
				delay={delay}
			/>
		</StyledMenu>
	);
};
